import { VueConstructor } from "vue";
import AlertBadge from "@/components/AlertBadge.vue";
import AlertHistoryList from "@/components/AlertHistoryList.vue";
import AlertNotifications from "@/components/AlertNotifications.vue";
import AlertTriggerControls from "@/components/AlertTriggerControls.vue";
import AlertTriggersList from "@/components/AlertTriggersList.vue";
import AlertTriggerToggle from "@/components/AlertTriggerToggle.vue";
import ChartIQ from "@/components/ChartIQ.vue";
import PortfolioList from "@/components/PortfolioList.vue";
import Portfolio from "@/components/Portfolio.vue";
import PortfolioPositionsTopFlop from "@/components/PortfolioPositionsTopFlop.vue";
import PortfolioPositionsPerformance from "@/components/PortfolioPositionsPerformance.vue";
import Watchlist from "@/components/Watchlist.vue";
import WatchlistList from "@/components/WatchlistList.vue";

interface Widget {
  name: string;
  widget: VueConstructor;
}

const prefix = "egb";

const widgets: Widget[] = [
  {
    name: `${prefix}-alert-badge`,
    widget: AlertBadge,
  },
  {
    name: `${prefix}-alert-history-list`,
    widget: AlertHistoryList,
  },
  {
    name: `${prefix}-alert-notifications`,
    widget: AlertNotifications,
  },
  {
    name: `${prefix}-alert-trigger-controls`,
    widget: AlertTriggerControls,
  },
  {
    name: `${prefix}-alert-triggers-list`,
    widget: AlertTriggersList,
  },
  {
    name: `${prefix}-alert-trigger-toggle`,
    widget: AlertTriggerToggle,
  },
  {
    name: `${prefix}-chart`,
    widget: ChartIQ,
  },
  {
    name: `${prefix}-portfolio-list`,
    widget: PortfolioList,
  },
  {
    name: `${prefix}-portfolio`,
    widget: Portfolio,
  },
  {
    name: `${prefix}-portfolio-positions-top-flop`,
    widget: PortfolioPositionsTopFlop,
  },
  {
    name: `${prefix}-portfolio-positions-performance`,
    widget: PortfolioPositionsPerformance,
  },
  {
    name: `${prefix}-watchlist`,
    widget: Watchlist,
  },
  {
    name: `${prefix}-watchlist-list`,
    widget: WatchlistList,
  },
];
export default widgets;
